import { environment } from "src/environments/environment";

const userBaseUrl = `${environment.url}/api/MainSite/`;
const baseUrl = `${environment.url}/api/`;
const ebUrl = `${environment.url}/api/MasterData/`;

export const ENDPOINTS = {
	user: {
		login: `${userBaseUrl}Login`,
		getProfile: `${userBaseUrl}GetProfile`
	},
	home: {
		getListing: `${baseUrl}GetListing`,
		getListingExcel: `${baseUrl}GetListingExcel`,
		getDetailById: `${baseUrl}GetDetailById/`,
		updateStatus: `${baseUrl}UpdateClaimStatus/`,
		getInspectionReportDetailById: `${baseUrl}GetInspectionReportDetailById/`,
		downloadInspectionReportById: `${baseUrl}DownloadInspectionReportDocumentById/`,
		downloadClaimDocuments: `${baseUrl}DownloadClaimDocuments/`
	},
	eb: {
		submitInquiryForm: `${baseUrl}Endorsement/SubmitEBContactForm`
	},
	partner: {
		submitInquiryForm: `${baseUrl}Partner/SubmitPartnerContactForm`
	},
	banner: {
		getActiveBanners: `${baseUrl}Banner/GetActiveBanners`
	},
	blog: {
		getActivePosts: `${baseUrl}Blog/GetActivePosts`,
		getActivePostsBySlug: `${baseUrl}Blog/GetActivePostsBySlug`
	},
	tnc: {
		getActiveTncs: `${baseUrl}Tnc/GetActiveTncs`
	}
};
